<template>
  <div class="showcase-home-hero-complete">
    <div class="header">
      <div class="title">{{ currentStep.title }}</div>
      <div class="status">{{ statusText }}</div>
    </div>
    <div class="content">
      <div class="action">
        <button
          class="button outline white transparent blur big block"
          @click="onClickLoginButton"
        >
          立即登录
        </button>
        <button
          class="button outline white transparent blur big block"
          @click="onClickBindWxButton"
        >
          绑定微信
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default defineComponent({
  name: 'ShowcaseHomeHeroComplete',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      defaultStatusText: '长风破浪，直挂云帆。',
      statusText: '长风破浪，直挂云帆。',
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentStepName: 'invite/currentStepName',
      currentStep: 'invite/currentStep',
      inviteCode: 'invite/validate/inviteCode',
      isValidInviteCode: 'invite/validate/isValidInviteCode',
      name: 'invite/register/name',
      password: 'invite/register/password',
    }),
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    ...mapActions({
      login: 'auth/login/login',
    }),

    async onClickLoginButton() {
      if (this.name && this.password) {
        try {
          await this.login({
            name: this.name,
            password: this.password,
            device: { type: 'web' },
          });

          this.$router.push('/');
        } catch (error) {
          this.setCurrentStepName('login');
        }
      } else {
        this.setCurrentStepName('login');
      }
    },

    onClickBindWxButton() {
      this.setCurrentStepName('weixinLogin');
    },
  },

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/showcase-home-hero-complete.css';
</style>
